/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import CommonTransactionApprovalCard from "../../../../components/_utils/CommonTransactionApprovalCard/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import InternalScheduleTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalScheduleTxnDeclinePopup.jsx";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index.jsx";
import InternalAccountDetailsPopup from "../../../../components/Accounts/InternalAccount/InternalAccountDetailsPopup/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import ScheduleTxnOccurrencesPopup from "../../../../components/ScheduleTransactions/ScheduleTxnOccurrencesPopup/index.jsx";
import ScheduleInternalTransactionDetailPopup from "../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionDetailPopup/index.jsx";
import { getAllInternalAccounts } from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  ownerAccountsBalanceRefresh,
  ownerAccountsViewAll,
  setshowsuccestoast,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import {
  scheduledInternalApprove,
  scheduledInternalOccurrences,
  scheduledInternalReject,
  scheduledInternalViewAll,
  scheduledInternalAddLabel,
  scheduledInternalRemoveLabel,
} from "../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";

const ScheduleInternalTransactionSingleApproval = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const [, setIsOpen] = useState(false);
  const [active, setActive] = useState("");
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchdata, setSearchdata] = useState("");
  const [scheduleId, setScheduleId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [ownerAccId, setOwnerAccId] = useState("");
  const [ownerAccNo, setOwnerAccNo] = useState("");
  const [formatedData, setFormatedData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [endDateFilter, setEndDateFilter] = useState("");
  const [internalAccNo, setInternalAccNo] = useState("");
  const [internalAccId, setInternalAccId] = useState("");
  const [occurrenceData, setOccurrenceData] = useState([]);
  const [transactionData, setTransactionData] = useState([]);
  const [txnAmountFilter, setTxnAmountFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [wasActionLoading, setWasActionLoading] = useState(false);
  const [internalScheduleId, setInternalScheduleId] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("");
  const [internalAccIdFilter, setInternalAccIdFilter] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [openOccurrencePopup, setOpenOccurrencePopup] = useState(false);
  const [isAdditionalPopupOpen, setIsAdditionalPopupOpen] = useState("");
  const [frequencyMethodfilter, setFrequencyMethodfilter] = useState("");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [scheduleIntTxnLoading, setscheduleIntTxnLoading] = useState(false);
  const [approveRejectBtnClicked, setApproveRejectBtnClicked] = useState({});
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState("");
  const [internalAccDetailPopOpen, setInternalAccDetailPopOpen] =
    useState(false);
  const [selectedPageValue, setSelectedPageValue] = useState(
    PaginationConfiguration.paginationSmall,
  );

  const labelActionDispatchedRef = useRef(false);
  const [labeltxnid, setLabeltxnid] = useState([]);
  const [txnlabels, settxnLabels] = useState([]);
  const [labelSearchText, setLabelSearchText] = useState([]);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const {
    scheduledInternalViewLoading,
    scheduledInternalApproveLoading,
    scheduledInternalRejectLoading,
  } = useSelector((state) => state.scheduleInternalTransactions);

  const hasOccurrenceService = services?.includes("IOScheduledTxn");

  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const formatDate = (date) => {
    const day = String(date.getDate())?.padStart(
      GlobalConfiguration.lengthCheckTwo,
      GlobalConfiguration.dashboardPrimaryCount,
    );
    const month = String(
      date.getMonth() + GlobalConfiguration.lengthCheckOne,
    )?.padStart(
      GlobalConfiguration.lengthCheckTwo,
      GlobalConfiguration.dashboardPrimaryCount,
    );
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatedTxnPeriod = (dateString) => {
    const d = new Date(dateString);
    const day = d.toLocaleDateString("en-GB", { day: "numeric" });
    const month = d.toLocaleDateString("en-GB", {
      month: "short",
    });
    const year = d.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      if (active === "Labels") {
        const q = String(searchUserTextDebounce || "").toLowerCase();
        data = (txnlabels || [])
          .filter((l) => l.toLowerCase().includes(q))
          .map((l) => ({ id: l, Label: l }));
        return;
      }

      const searchString = String(searchUserTextDebounce || "").trim();
      if (!searchString) {
        data = [];
        return;
      }

      switch (active) {
        case "Internal account": {
          const numericOnly = searchString.replace(/\D/g, "");
          const internalParams =
            numericOnly.length >= GlobalConfiguration.accountminLength
              ? {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  bank_account_no: numericOnly,
                  type: "internalAccount",
                }
              : {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  search_string: searchString,
                  type: "internalAccount",
                };

          response = await dispatch(getAllInternalAccounts(internalParams));

          data =
            response?.payload?.internal_accounts?.map((itm) => ({
              id: itm.id,
              display: itm.name
                ? `${itm.bank_acc_no || ""} - ${itm.name}`
                : itm.bank_acc_no || itm.id,
              bank_account_no: itm.bank_acc_no,
              name: itm.name,
              ifsc_code: itm.ifsc_code,
              email_id: itm.email_id,
            })) || [];
          break;
        }

        case "Owner account": {
          const numericOnlyOwn = searchString.replace(/\D/g, "");
          const ownerParams =
            numericOnlyOwn.length >= GlobalConfiguration.accountminLength
              ? {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  bank_account_no: numericOnlyOwn,
                }
              : {
                  page_no: GlobalConfiguration.lengthCheckOne,
                  page_size: GlobalConfiguration.panLength,
                  search_string: searchString,
                };
          response = await dispatch(ownerAccountsViewAll(ownerParams));
          data =
            response?.payload?.owner_accounts?.map((itm) => ({
              id: itm.id,
              display: itm.name
                ? `${itm.bank_acc_no || ""} - ${itm.name}`
                : itm.bank_acc_no || itm.id,
              bank_account_no: itm.bank_acc_no,
              name: itm.name,
              ifsc_code: itm.ifsc_code,
              email_id: itm.email_id,
            })) || [];
          break;
        }

        case "Category":
        case "Search":
          setSearchdata(searchUserTextDebounce);
          setLoadingData(false);
          break;
        case "Amount":
        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const handleAction = async () => {
    try {
      setscheduleIntTxnLoading(true);

      let queryParams = {
        page_no: currentPage,
        page_item_count: selectedPageValue,
        lifecycle_status: "pending",
      };

      if (searchdata && searchdata !== "") {
        queryParams.scheduled_name = searchdata;
      }

      if (frequencyMethodfilter && frequencyMethodfilter !== "") {
        queryParams.frequency = frequencyMethodfilter;
      }

      if (startDateFilter && startDateFilter !== "") {
        queryParams.transaction_start_date = formatDate(startDateFilter);
      }

      if (endDateFilter && endDateFilter !== "") {
        queryParams.transaction_end_date = formatDate(endDateFilter);
      }
      if (paymentMethodFilter && paymentMethodFilter !== "") {
        queryParams.payment_method = paymentMethodFilter;
      }
      if (confidentialMethodFilter && confidentialMethodFilter !== "") {
        queryParams.confidential_transaction = confidentialMethodFilter;
      }

      if (
        txnAmountFilter &&
        txnAmountFilter > GlobalConfiguration.lengthCheckZero
      ) {
        queryParams.amount = txnAmountFilter;
      }

      if (internalAccIdFilter && internalAccIdFilter !== "") {
        queryParams.internal_account_id = internalAccIdFilter;
      }

      if (ownerAccId && ownerAccId !== "") {
        queryParams.owner_account_id = ownerAccId;
      }

      if (labelSearchText?.length) {
        queryParams.labels = labelSearchText;
      }

      const response = await dispatch(
        scheduledInternalViewAll(
          queryParams,
          // services,
        ),
      );
      const newData = response?.payload?.transactions || [];

      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTransactionData(response?.payload);
      setFormatedData(formattedData);
    } catch (error) {
      console.error("Error in API call:", error);
      setTransactionData([]);
      setFormatedData([]);
    } finally {
      setscheduleIntTxnLoading(false);
    }
  };
  useEffect(() => {
    const isActionLoading =
      scheduledInternalApproveLoading || scheduledInternalRejectLoading;
    if (isAdditionalPopupOpen && isActionLoading) {
      setWasActionLoading(true);
    } else if (isAdditionalPopupOpen && wasActionLoading && !isActionLoading) {
      setTimeout(() => {
        setIsAdditionalPopupOpen("");
        setWasActionLoading(false);
      }, IntervalConfiguration.intervalExtraLarge);
    }
  }, [
    scheduledInternalApproveLoading,
    scheduledInternalRejectLoading,
    isAdditionalPopupOpen,
  ]);

  const handleTxnAction = async (id, reason = "", type) => {
    const isReject = type === "reject";
    const toastMsg = isReject ? "Rejecting schedule" : "Approving schedule";
    const reduxAction = isReject
      ? scheduledInternalReject
      : scheduledInternalApprove;

    setLoading((prev) => ({ ...prev, [id]: true }));
    UniversalRefreshToast(toastMsg);

    const data = await dispatch(
      reduxAction({
        id,
        reason,
        services,
        navigate,
      }),
    );

    let errorMessage = "";
    let lifecycleStatus = "";

    const payload = data?.payload;

    if (payload?.status === errorcode.errorFailed) {
      lifecycleStatus = "pending";
      setTimeout(
        () =>
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          }),
        IntervalConfiguration.intervalExtraLarger,
      );
    }

    if (
      payload?.errors?.user_unauthorized?.[GlobalConfiguration.lengthCheckZero]
    ) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "VBeneficiaryTxn" },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      return;
    }

    if (payload?.status !== errorcode.errorNotFound) {
      const updatedData = formatedData?.map((item) => {
        if (item.txn_id === id) {
          const txn =
            payload?.transactions?.[GlobalConfiguration.lengthCheckZero];
          const isSuccess = payload?.status === true;
          const isLifecycleMatch = isReject
            ? txn?.lifecycle_status === "rejected"
            : txn?.lifecycle_status === "approved";

          if (isSuccess && isLifecycleMatch) {
            lifecycleStatus = txn.lifecycle_status;
          } else if (
            payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]?.errors
              ?.length > GlobalConfiguration.lengthCheckZero
          ) {
            errorMessage =
              payload.errors.base[
                GlobalConfiguration.lengthCheckZero
              ].errors.join(", ");
            payload.errors.base[
              GlobalConfiguration.lengthCheckZero
            ].errors.forEach((msg) =>
              setTimeout(
                () =>
                  CommonToast({
                    text: msg,
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  }),
                IntervalConfiguration.intervalExtraLarger,
              ),
            );
          }

          return {
            ...item,
            lifecycle_status:
              isSuccess && item.lifecycle_status === "pending"
                ? lifecycleStatus
                : "error",
            error:
              item.error === "false" && payload.status === false
                ? "true"
                : item.error,
            message:
              isReject && isSuccess && isLifecycleMatch
                ? reason
                : !isReject && item.message === "" && payload.status === false
                  ? errorMessage
                  : item.message,
            rejection_reason:
              isReject && isSuccess && isLifecycleMatch
                ? txn?.rejection_reason
                : item.rejection_reason,
            last_updated_user_id_check:
              item.last_updated_user_id_check === "false" &&
              isSuccess &&
              loginid.employees.id === txn?.last_updated_user_id
                ? "true"
                : item.last_updated_user_id_check,
          };
        }
        return item;
      });

      setFormatedData(updatedData);
    }

    setTimeout(() => {
      setLoading((prev) => ({ ...prev, [id]: false }));
      toast.dismiss();
    }, IntervalConfiguration.intervalExtraLarge);

    setTimeout(() => {
      if (
        payload?.status === true &&
        payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status === lifecycleStatus
      ) {
        CommonToast({
          text: `Schedule ${isReject ? "rejected" : "approved"} successfully`,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      if (payload?.status === errorcode.errorNotFound) {
        CommonToast({
          text: payload?.error,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }, IntervalConfiguration.intervalExtraLarge);

    if (isReject) setShowRejectPopup(false);
    setApproveRejectBtnClicked((prev) => ({ ...prev, [id]: "none" }));
  };

  const getErrorMessage = (res) => {
    const p = res?.payload;

    const unsuccessful =
      p?.ids?.unsuccessful_ids || p?.response?.data?.ids?.unsuccessful_ids;

    if (Array.isArray(unsuccessful) && unsuccessful.length) {
      const messages = unsuccessful
        .flatMap((item) =>
          Array.isArray(item?.errors) ? item.errors : [item?.errors],
        )
        .filter(Boolean);
      if (messages.length) return Array.from(new Set(messages)).join(", ");
    }

    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }

    const e = res?.error;
    if (e?.message && e.message !== "Rejected") return e.message;
    return "Something went wrong";
  };

  const showLabelToast = (text, ok) => {
    toast.dismiss();
    CommonToast({
      text,
      icon: ok
        ? ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE
        : ICONS?.ERROR_WITH_WHITE_CIRCLE,
      variant: ok ? "var(--success)" : "var(--error)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);
    const res = await dispatch(
      scheduledInternalAddLabel({
        record_ids: labeltxnid,
        labels: labelsToAssign,
      }),
    );
    const ok = scheduledInternalAddLabel.fulfilled.match(res);

    if (ok) {
      showLabelToast("Labels assigned successfully.", true);
      await handleAction();
      labelActionDispatchedRef.current = true;
    } else {
      showLabelToast(getErrorMessage(res), false);
    }

    setLabelPopupLoading(false);
    return ok;
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);
    const res = await dispatch(
      scheduledInternalRemoveLabel({
        record_ids: labeltxnid,
        labels: labelsToUnassign,
      }),
    );
    const ok = scheduledInternalRemoveLabel.fulfilled.match(res);

    if (ok) {
      showLabelToast("Labels unassigned successfully.", true);
      await handleAction();
      labelActionDispatchedRef.current = true;
    } else {
      showLabelToast(getErrorMessage(res), false);
    }

    setLabelPopupLoading(false);
    return ok;
  };

  const handleLabelPopupClose = () => {
    setIsLabelPopupOpen(false);
    if (labelActionDispatchedRef.current) {
      labelActionDispatchedRef.current = false;
      handleAction();
    }
  };

  useEffect(() => {
    settxnLabels(transactionData?.summary?.available_labels || []);
  }, [transactionData]);

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      CommonToast({
        text: "Refreshing balance",
        icon: ICONS?.LOADER_GIF,
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnText: "",
          handleFunction: () => {},
          icon: "",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();
      }, GlobalConfiguration.inputMaxLength);
    }
  }, [ownerAccBalanceLoading]);

  const handleRefresh = async (e, id, prevBalance) => {
    e.stopPropagation();
    try {
      let response = await dispatch(ownerAccountsBalanceRefresh(id));

      if (response?.payload?.status === true) {
        let data = formatedData?.map((item) => {
          if (
            response?.payload?.owner_accounts[
              GlobalConfiguration.lengthCheckZero
            ]?.owner_account_id === item?.owner_account_id
          ) {
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response?.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response?.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_balance,
              owner_account_balance_last_fetched_at:
                response?.payload.owner_accounts[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_balance_last_fetched_at,
            };
          }
          return item;
        });
        setFormatedData(data);
        setTimeout(() => {
          CommonToast({
            text: "Balance refreshed successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
          dispatch(setshowsuccestoast());
        }, PaginationConfiguration.paginationMid);
      } else {
        toast.dismiss();
        CommonToast({
          text:
            response?.payload?.response?.data?.errors?.base[
              GlobalConfiguration.lengthCheckZero
            ] || "Error refreshing balance",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  };

  const handleOpenOccurrence = async (
    transaction_start_date,
    transaction_end_date,
    frequency,
  ) => {
    try {
      const response = await dispatch(
        scheduledInternalOccurrences({
          frequency,
          transaction_start_date,
          transaction_end_date,
          services,
          navigate,
        }),
      );
      setOccurrenceData(response.payload);
      setOpenOccurrencePopup(true);
    } catch (error) {
      console.error("Error fetching occurrences:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChangePageSize = (value) => {
    setSelectedPageValue(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne || currentPage);
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccDetailPopOpen(!internalAccDetailPopOpen);
  };

  const closeScheduleInternalTxnModal = () => {
    setIsAdditionalPopupOpen("");
  };

  const handleFrequencyMethod = (selectedSettlement) => {
    const value = selectedSettlement.toLowerCase().replace(/ /g, "_");
    setFrequencyMethodfilter(value);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setPaymentMethodFilter(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const handleStartDateMethod = (selectedSettlement) => {
    setStartDateFilter(selectedSettlement);
  };

  const handleEndDateMethod = (selectedSettlement) => {
    setEndDateFilter(selectedSettlement);
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();
    setIsFilterApplied(
      !(
        paymentMethodFilter === "" &&
        frequencyMethodfilter === "" &&
        confidentialMethodFilter === "" &&
        ownerAccNo === "" &&
        internalAccNo === "" &&
        startDateFilter === "" &&
        endDateFilter === "" &&
        txnAmountFilter === "" &&
        searchdata === "" &&
        !labelSearchText.length
      ),
    );
  }, [
    dispatch,
    selectedPageValue,
    currentPage,
    frequencyMethodfilter,
    startDateFilter,
    internalAccIdFilter,
    paymentMethodFilter,
    ownerAccId,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    markerData,
    labelSearchText,
  ]);

  const handleAmountChange = (val) => {
    setTxnAmountFilter(val);
  };
  const FrequencyOptions = [
    "once",
    "daily",
    "weekly",
    "fortnightly",
    "monthly",
    "quarterly",
    "half_yearly",
    "yearly",
  ];

  const formatFrequencyLabel = (value) =>
    typeof value === "string"
      ? value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  const formattedFrequencyOptions = FrequencyOptions.map(formatFrequencyLabel);

  const filterItems = [
    {
      name: "Search",
      isMulti: false,
      value: searchdata,
      setValue: setSearchdata,
      isDropdown: false,
      isDisabled: loading,
    },
    {
      name: "Internal account",
      short_name: "Int. Acc",
      isMulti: false,
      value: internalAccIdFilter,
      displayValue: internalAccNo,
      setValue: (val) => setInternalAccIdFilter(val),
      setDisplayValue: (val) => setInternalAccNo(val),
      isDropdown: true,
      valueType: "string",
      isDisabled: scheduleIntTxnLoading,
    },
    {
      name: "Owner account",
      short_name: "Own. Acc",
      isMulti: false,
      value: ownerAccId,
      displayValue: ownerAccNo,
      setValue: (val) => setOwnerAccId(val),
      setDisplayValue: (val) => setOwnerAccNo(val),
      isDropdown: true,
      valueType: "string",
      isDisabled: scheduleIntTxnLoading,
    },
    {
      name: "Labels",
      short_name: "Lab",
      isMulti: true,
      value: labelSearchText,
      setValue: (val) => {
        setCurrentPage(GlobalConfiguration.lengthCheckOne);
        setLabelSearchText(val);
        setActive("");
      },
      isDropdown: true,
      valueType: "string",
      isDisabled: scheduleIntTxnLoading,
    },
    {
      name: "Amount",
      short_name: "Amt",
      isMulti: false,
      value: txnAmountFilter,
      setValue: handleAmountChange,
      displayValue: FormatAmount({ price: txnAmountFilter }),
      isDropdown: false,
      valueType: "number",
      isDisabled: scheduleIntTxnLoading,
    },
  ];
  const filters = [
    {
      name: "Schedule start date",
      filterType: "calender",
      variant: "single",
      value: startDateFilter,
      handleChange: handleStartDateMethod,
      startDate: startDateFilter ? new Date(startDateFilter) : null,
      endDate: null,
      isDisabled: false,
      size: "small",
      minDate: new Date(),
      maxDate: null,
    },

    {
      name: "Schedule end date",
      filterType: "calender",
      variant: "single",
      value: endDateFilter,
      handleChange: handleEndDateMethod,
      startDate: endDateFilter ? new Date(endDateFilter) : null,
      endDate: null,
      isDisabled: false,
      size: "small",
      minDate: startDateFilter || new Date(),
      maxDate: null,
    },
    {
      name: "Frequency",
      filterType: "dropdown",
      variant: "single",
      options: formattedFrequencyOptions,
      isSearch: true,
      dropdownPlaceHolder: "Select frequency",
      searchPlaceholder: "Search frequency",
      value: formatFrequencyLabel(frequencyMethodfilter),
      handleChange: handleFrequencyMethod,
      isDisabled: false,
      size: "small",
    },
    {
      name: "Payment method",
      filterType: "dropdown",
      variant: "single",
      options: ["NEFT", "RTGS"],
      dropdownPlaceHolder: "Select type",
      value: paymentMethodFilter,
      handleChange: handlePaymentMethod,
      dropdownType: "PaymentMethod",
      isDisabled: false,
      size: "small",
    },

    {
      name: "Show/hide confidential transactions",
      filterType: "dropdown",
      variant: "single",
      options: ["Show only confidential", "Hide confidential"],
      isSearch: false,
      dropdownPlaceHolder: "Default (all transactions)",
      searchPlaceholder: "",
      value: confidentialMethodFilter,
      handleChange: handleConfidentialMethod,
      isDisabled: false,
      size: "small",
    },
  ];

  const updateAllTxn = (updatedTxn) => {
    setFormatedData(updatedTxn);
  };

  const isSearchClearAllDisabled = !filterItems?.some(
    (f) => String(f?.value)?.length,
  );

  const isFilterClearAllDisabled = !filters?.some((f) =>
    Array.isArray(f?.value) ? f.value.length : Boolean(f?.value),
  );

  return (
    <>
      {openOccurrencePopup && (
        <div
          style={{ zIndex: "var(--z-index-max)" }}
          className="fixed top-top-base left-left-base w-full h-full "
        >
          <ScheduleTxnOccurrencesPopup
            closeCallback={() => setOpenOccurrencePopup(false)}
            occurrences={occurrenceData?.dates || []}
          />
        </div>
      )}

      {showRejectPopup && (
        <InternalScheduleTxnDeclinePopup
          allTxnData={formatedData}
          handleClose={() => {
            setShowRejectPopup(false);
            setApproveRejectBtnClicked({
              ...approveRejectBtnClicked,
              [scheduleId]: "none",
            });
          }}
          txnId={scheduleId}
          updateAllTxn={updateAllTxn}
          toastType="singleSchedule"
        />
      )}

      {internalAccDetailPopOpen && internalAccId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={internalAccId}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}

      {isAdditionalPopupOpen !== "" && internalScheduleId !== "" ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ScheduleInternalTransactionDetailPopup
            closeScheduleInternalTxnModal={closeScheduleInternalTxnModal}
            schedule_internaltxn_id={internalScheduleId}
            detailSelected={isAdditionalPopupOpen}
            type={"bene_account_detail_modal"}
            flow={"Schedule_txn_detail_modal"}
          />
        </div>
      ) : null}

      {isLabelPopupOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated schedules."
            closehandleFunction={handleLabelPopupClose}
            closeisDisabled={false}
            labels={txnlabels}
            setLabels={settxnLabels}
            LabelAccounts={labeltxnid}
            isLabelPopupOpen={isLabelPopupOpen}
            filteredData={formatedData
              ?.filter((t) => labeltxnid.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleLabelPopupClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
          />
        </div>
      )}

      <div
        className={`w-width-full flex flex-col ${
          !scheduledInternalViewLoading &&
          !scheduleIntTxnLoading &&
          formatedData?.length === GlobalConfiguration.lengthCheckOne
            ? "h-screen overflow-hidden"
            : " h-screen overflow-hidden"
        } ${showInnerSearchBar ? "bg-PopUp-BackDrop" : ""}`}
      >
        <div className="Qsmd:h-navbar-breadcrumb-height bg-primary-nav flex-shrink-0"></div>
        <div className="w-full bg-primary-nav relative z-z-index-header ">
          <div className="w-full z-z-index-header opacity-base-opacity">
            <div className="w-full flex flex-row-reverse items-end Qlg:px-padding-base">
              <TopNavComponent
                filteredSearchProps={{
                  onSearchInput: handleSearch,
                  searchInputRef: filterRef,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search schedule internal transaction",
                  filterPlaceholder: "schedule name",
                  isSearchDisabled: loading || scheduleIntTxnLoading,
                  filterItems: filterItems,
                  loading: scheduleIntTxnLoading,
                  inputData: inputData,
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  isShowFilter: true,
                  filters: filters,
                  isFilterClearAllDisabled: isFilterClearAllDisabled,
                  isSearchClearAllDisabled: isSearchClearAllDisabled,
                  active: active,
                  setActive: setActive,
                  loadingData: loadingData,
                }}
                BottomHeader="Schedule Approval Process"
                BottomSubText="Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
                iconComponentArray={[]}
                assignLabelProps={null}
                assignTagProps={null}
                toggleProps={{
                  handleClick: () => {
                    navigate(
                      "/internal_transaction_dashboard/schedule_multi_approval",
                    );
                  },
                  title: "Multi Approval",
                  state: true,
                }}
                isSelectionView={false}
                selectionText={null}
                selectionBtnProps={null}
                handleBack={() => navigate(GlobalConfiguration.navigate_back)}
              />
            </div>
          </div>
        </div>
        <div
          className={`justify-center items-center h-full overflow-y-auto overflow-x-hidden flex-1 ${
            isFilterApplied ? "internal-schcdule-main-div-con" : ""
          } ${showInnerSearchBar && "bg-PopUp-BackDrop opacity-light-opacity"}`}
        >
          <div
            className="w-width-full overflow-y-auto  h-[-webkit-fill-available] z-z-index-content scroll-py-top_xl"
            style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
          >
            {scheduleIntTxnLoading || scheduledInternalViewLoading ? (
              <div
                style={{
                  opacity: showInnerSearchBar
                    ? "var(--opcacity_none)"
                    : "var(--base-opacity)",
                }}
                className="loader-container m-auto justify-center items-center flex h-height-full"
              >
                <Loader />
              </div>
            ) : !formatedData?.length ? (
              <div className="w-full h-full flex flex-col justify-center items-center">
                <img
                  src={
                    isFilterApplied
                      ? ICONS?.NO_DATA_FOUND
                      : ICONS?.NO_PENDING_TRANSACTION
                  }
                  alt="NoAccountRemain"
                />
                <div className="w-full mt-margin-md text-text-primary text-font-sm text-center">
                  {isFilterApplied
                    ? "No data found."
                    : "There are no more transactions that require your approval."}
                </div>
                <div className="mt-margin-md">
                  <PrimaryButton
                    btnText={
                      isFilterApplied
                        ? "Clear parameters"
                        : "Internal transaction dashboard"
                    }
                    enabledBgColor="var(--primary-act)"
                    handleFunction={() => {
                      if (isFilterApplied) {
                        setPaymentMethodFilter("");
                        setFrequencyMethodfilter("");
                        setConfidentialMethodFilter("");
                        setOwnerAccNo("");
                        setOwnerAccId("");
                        setInternalAccNo("");
                        setInternalAccIdFilter("");
                        setStartDateFilter("");
                        setEndDateFilter("");
                        setTxnAmountFilter("");
                        setSearchdata("");
                        setLabelSearchText([]);
                      } else {
                        navigate("/internal_transaction_dashboard");
                      }
                    }}
                    enabledTextColor="var(--text-primary)"
                    hoverOption="white"
                  />
                </div>
              </div>
            ) : (
              <div className="flex flex-col gap-gap-md items-center px-padding-md py-padding-md">
                {(() => {
                  const uniqueFormatedData =
                    formatedData?.filter(
                      (data, index, self) =>
                        index ===
                        self.findIndex((d) => d.txn_id === data.txn_id),
                    ) || [];

                  return uniqueFormatedData.map((data, index) =>
                    data ? (
                      <div
                        key={data.txn_id || index}
                        className={`w-width-full Qlg:flex Qlg:justify-center z-z-index-base relative ${showInnerSearchBar ? "bg-PopUp-BackDrop opacity-light-opacity" : ""}`}
                      >
                        {(() => {
                          const amountFormatted = (() => {
                            const amount = Number(data?.amount);

                            if (!amount) return "INR 0.00";

                            return `INR ${new Intl.NumberFormat("en-IN", {
                              minimumFractionDigits:
                                GlobalConfiguration.lengthCheckTwo,
                              maximumFractionDigits:
                                GlobalConfiguration.lengthCheckTwo,
                            }).format(amount)}`;
                          })();

                          const transactionPeriodFormatted = `${formatedTxnPeriod(data?.transaction_start_date || "")} - ${formatedTxnPeriod(data?.transaction_end_date || "")}`;

                          const freq = data?.frequency?.toLowerCase();
                          const formattedFreq =
                            freq === "half_yearly"
                              ? "Half yearly"
                              : freq
                                  ?.charAt(GlobalConfiguration.lengthCheckZero)
                                  .toUpperCase() +
                                freq?.slice(GlobalConfiguration.lengthCheckOne);
                          const frequencyFormatted = formattedFreq;

                          const occurrencesOnClick = services?.includes(
                            "ICScheduledTxn",
                          )
                            ? () =>
                                handleOpenOccurrence(
                                  data?.transaction_start_date,
                                  data?.transaction_end_date,
                                  data?.frequency,
                                )
                            : () =>
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "ICScheduledTxn",
                                  },
                                });

                          const additionalDetailsOnClick = () => {
                            setInternalScheduleId(data?.txn_id);
                            setIsAdditionalPopupOpen("Additional details");
                          };

                          const overlay1CtaOnClick = () => {
                            if (
                              data?.lifecycle_status === "pending" &&
                              data?.internal_account_approval_status ===
                                "pending"
                            ) {
                              if (services?.includes("IVAccount")) {
                                setInternalAccDetailPopOpen(true);
                                setInternalAccId(data?.internal_account_id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "IVAccount",
                                  },
                                });
                              }
                            } else {
                              setInternalScheduleId(data?.txn_id);
                              setIsAdditionalPopupOpen("Details");
                            }
                          };

                          const ownerAccountBalanceRaw =
                            data?.owner_account_balance !== undefined
                              ? data?.owner_account_balance
                              : "0";

                          const ownerAccountBalanceOnClick = (e) => {
                            if (services?.includes("VAccountBalance")) {
                              handleRefresh(
                                e,
                                data?.owner_account_id,
                                data?.owner_account_balance,
                              );
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "VAccountBalance",
                                },
                              });
                            }
                          };

                          const approveClick = () => {
                            setApproveRejectBtnClicked({
                              ...approveRejectBtnClicked,
                              [data?.txn_id]: "approve",
                            });
                            handleTxnAction(data?.txn_id);
                          };

                          const rejectClick = () => {
                            setApproveRejectBtnClicked({
                              ...approveRejectBtnClicked,
                              [data?.txn_id]: "reject",
                            });
                            setScheduleId(data?.txn_id);
                            setShowRejectPopup(true);
                          };

                          const cardState =
                            data?.lifecycle_status === "rejected"
                              ? "double"
                              : (data?.lifecycle_status === "pending" &&
                                    data?.internal_account_approval_status ===
                                      "pending") ||
                                  data?.lifecycle_status === "approved" ||
                                  (data?.lifecycle_status === "error" &&
                                    data?.error === "true")
                                ? "single"
                                : "default";

                          const overlay1Text =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status === "pending"
                              ? "Account approval pending"
                              : data?.lifecycle_status === "approved"
                                ? "Approved"
                                : data?.lifecycle_status === "error" &&
                                    data?.error === "true"
                                  ? "Failed to take action"
                                  : data?.lifecycle_status === "rejected"
                                    ? "Rejected"
                                    : "Unknown error";

                          const overlay1Subtext =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status === "pending"
                              ? "Account is not approved, please approve account before approving transaction."
                              : data?.lifecycle_status === "approved"
                                ? "This schedule has been approved."
                                : data?.lifecycle_status === "error" &&
                                    data?.error === "true"
                                  ? "Unable to retrieve the schedule status. Try refreshing the page."
                                  : data?.lifecycle_status === "rejected"
                                    ? "This schedule has been rejected!"
                                    : "An error occurred while taking action on this schedule.";

                          const overlay1Icon =
                            data?.lifecycle_status === "approved"
                              ? ICONS.APPROVED_LINEAR
                              : data?.lifecycle_status === "error" &&
                                  data?.error === "true"
                                ? ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                : data?.lifecycle_status === "rejected"
                                  ? ICONS?.REJECTED_RED
                                  : undefined;

                          const overlay1IconColor = undefined;

                          const overlay1CtaText =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status === "pending"
                              ? "Approve account"
                              : "View schedule";

                          const accountApprovalPending =
                            data?.lifecycle_status === "pending" &&
                            data?.internal_account_approval_status ===
                              "pending";

                          return (
                            <div>
                              <CommonTransactionApprovalCard
                                overrideAutoLoader
                                whichBtnClicked={
                                  approveRejectBtnClicked?.[data?.txn_id] ??
                                  "none"
                                }
                                entries={[
                                  [
                                    {
                                      type: "textSubtext",
                                      text: amountFormatted,
                                      textColor: "var(--settled)",
                                      subText: "Transaction amount",
                                      icon: ICONS?.INTERNAL_WITH_WHITE_CIRCLE,
                                      iconColor: "",
                                      isBold: true,
                                      fontSize: "font-sm",
                                    },
                                    {
                                      type: "textSubtext",
                                      text: data?.scheduled_name,
                                      subText: "Schedule name",
                                      icon:
                                        data?.confidential_transaction === "Y"
                                          ? ICONS.CONFIDENTIAL_TRANSACTION
                                          : undefined,
                                      iconColor: "",
                                    },
                                    {
                                      type: "cta",
                                      text: data?.labels?.length
                                        ? data.labels.join(", ")
                                        : "No labels assigned",
                                      subText: "Labels",
                                      onClick: (e) => {
                                        if (
                                          services?.includes("ALabel") &&
                                          services?.includes("RLabel")
                                        ) {
                                          e?.stopPropagation?.();
                                          setLabeltxnid([data?.txn_id]);
                                          setIsLabelPopupOpen(true);
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService:
                                                "ALabel,RLabel",
                                            },
                                          });
                                        }
                                      },
                                    },
                                  ],
                                  [
                                    {
                                      type: "textSubtext",
                                      text: transactionPeriodFormatted,
                                      subText: "Transaction period",
                                    },
                                    {
                                      type: "textSubtext",
                                      text: frequencyFormatted,
                                      subText: "Frequency",
                                    },
                                    {
                                      subText: "Occurrences",
                                      text: data?.occurrences || "",
                                      type: "text",
                                      onClick: occurrencesOnClick,
                                      isDisabled: !hasOccurrenceService,
                                    },
                                  ],
                                ]}
                                approveClick={
                                  cardState === "default"
                                    ? approveClick
                                    : undefined
                                }
                                rejectClick={
                                  cardState === "default"
                                    ? rejectClick
                                    : undefined
                                }
                                ctaBtn1Text="Additional details"
                                ctaBtn1OnClick={additionalDetailsOnClick}
                                ctaBtn2Text={undefined}
                                ctaBtn2OnClick={undefined}
                                alerts={[]}
                                cardState={cardState}
                                ownerAccountNumber={
                                  data?.owner_account_bank_acc_no
                                }
                                ownerAccountIfsc={
                                  data?.owner_account_ifsc_code || ""
                                }
                                ownerAccountNumberSubtext="Source account"
                                ownerAccountBalance={ownerAccountBalanceRaw}
                                ownerAccountBalanceSubtext={`Source account balance - ${data?.owner_account_balance_last_fetched_at_in_words || "Not available"}`}
                                ownerAccountBalanceOnClick={
                                  ownerAccountBalanceOnClick
                                }
                                destinationAccountNumber={
                                  data?.internal_account_bank_acc_no
                                }
                                destinationAccountIfsc={
                                  data?.internal_account_ifsc_code || ""
                                }
                                destinationAccountNumberSubtext="Destination account"
                                destinationAccountText={
                                  data?.internal_account_ifsc_code || ""
                                }
                                destinationAccountSubtext="IFSC code"
                                overlay1CtaDisabled={false}
                                overlay1CtaInactive={false}
                                overlay1CtaLoading={
                                  loading[data?.txn_id] || false
                                }
                                overlay1CtaOnClick={overlay1CtaOnClick}
                                overlay1CtaText={overlay1CtaText}
                                overlay1Text={overlay1Text}
                                overlay1Subtext={overlay1Subtext}
                                overlay1SubtextColor={
                                  data?.lifecycle_status === "pending" &&
                                  data?.internal_account_approval_status ===
                                    "pending"
                                    ? "var(--pending)"
                                    : "var(--text-primary)"
                                }
                                overlay1Icon={overlay1Icon}
                                overlay1IconColor={overlay1IconColor}
                                overlay2Subtext="Rejected reason"
                                overlay2Text={data?.rejection_reason || ""}
                                thisIsARecreateCard={false}
                                recreateOnClick={undefined}
                                recreateBtnText={undefined}
                                rejectBtnText="Reject schedule"
                                approveBtnText="Approve schedule"
                                accountApprovalPending={accountApprovalPending}
                              />
                            </div>
                          );
                        })()}
                      </div>
                    ) : null,
                  );
                })()}
              </div>
            )}
          </div>
        </div>
        {formatedData.length === GlobalConfiguration.lengthCheckZero ? null : (
          <div className="bottom-bottom-base sticky w-width-full flex items-center justify-center z-z-index-header">
            {showInnerSearchBar && (
              <div className="absolute inset-top-base z-z-index-overlay bg-PopUp-BackDrop opacity-dark-opacity" />
            )}

            <PaginationComponent
              handleSelect={handleChangePageSize}
              selectedValue={selectedPageValue}
              data={transactionData}
              dropdownOptions={PaginationConfiguration.paginationOptions}
              handlePagination={handlePageChange}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ScheduleInternalTransactionSingleApproval;
